"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeAhead = exports.Input = exports.Container = void 0;
var lodash_1 = __importDefault(require("lodash"));
var React = __importStar(require("react"));
var ReactDOM = __importStar(require("react-dom"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var matching_1 = require("../../utils/matching");
exports.Container = styled_components_1.default.div.attrs({
    className: 'tws-typeahead-container',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\toutline: none;\n"], ["\n\tposition: relative;\n\toutline: none;\n"])));
exports.Container.displayName = 'Container';
exports.Input = (0, styled_components_1.default)('input').attrs({
    className: 'tws-typeahead-input',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tborder: 0;\n\toutline: none;\n\tpadding: 10px;\n\twidth: 100%;\n\tfont-weight: 500;\n\t", "\n\t&::placeholder {\n\t\tcolor: #aaaaaa;\n\t}\n\t&:focus::-webkit-input-placeholder {\n\t\tcolor: transparent;\n\t}\n\t&:focus:-moz-placeholder {\n\t\tcolor: transparent;\n\t}\n\t&:focus::-moz-placeholder {\n\t\tcolor: transparent;\n\t}\n\t&:focus:-ms-input-placeholder {\n\t\tcolor: transparent;\n\t}\n"], ["\n\tborder: 0;\n\toutline: none;\n\tpadding: 10px;\n\twidth: 100%;\n\tfont-weight: 500;\n\t", "\n\t&::placeholder {\n\t\tcolor: #aaaaaa;\n\t}\n\t&:focus::-webkit-input-placeholder {\n\t\tcolor: transparent;\n\t}\n\t&:focus:-moz-placeholder {\n\t\tcolor: transparent;\n\t}\n\t&:focus::-moz-placeholder {\n\t\tcolor: transparent;\n\t}\n\t&:focus:-ms-input-placeholder {\n\t\tcolor: transparent;\n\t}\n"])), function (props) { return (props.deleted ? 'background-color: #eeeeee; text-decoration: line-through;' : ''); });
exports.Input.displayName = 'Input';
var ResultsContainer = styled_components_1.default.div.attrs({
    className: 'tws-typeahead-results-container',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tz-index: 9;\n\tbox-shadow: ", ";\n\tborder-radius: 3px;\n\tposition: absolute;\n\tbackground-color: ", ";\n\tmax-height: 425px;\n\toverflow-y: auto;\n\tmargin-top: 15px;\n"], ["\n\tz-index: 9;\n\tbox-shadow: ", ";\n\tborder-radius: 3px;\n\tposition: absolute;\n\tbackground-color: ", ";\n\tmax-height: 425px;\n\toverflow-y: auto;\n\tmargin-top: 15px;\n"])), globalVars_module_scss_1.default.shadow2, globalVars_module_scss_1.default.white);
ResultsContainer.displayName = 'ResultsContainer';
var OptionItem = (0, styled_components_1.default)('div').attrs({
    className: 'tws-typeahead-option',
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tpadding: 15px 16px;\n\tborder-bottom: ", " ", " ", ";\n\tfont-size: 13px;\n\tcursor: pointer;\n\tmin-width: 325px;\n\tline-height: 1.2em;\n\t&:hover {\n\t\tcolor: ", ";\n\t\tbackground: ", ";\n\t}\n\t&:last-child {\n\t\tborder-bottom: 0;\n\t}\n"], ["\n\tpadding: 15px 16px;\n\tborder-bottom: ", " ", " ", ";\n\tfont-size: 13px;\n\tcursor: pointer;\n\tmin-width: 325px;\n\tline-height: 1.2em;\n\t&:hover {\n\t\tcolor: ", ";\n\t\tbackground: ", ";\n\t}\n\t&:last-child {\n\t\tborder-bottom: 0;\n\t}\n"])), globalVars_module_scss_1.default.borderThin, globalVars_module_scss_1.default.borderSolid, globalVars_module_scss_1.default.secondaryGray2, globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.mainBlue);
OptionItem.displayName = 'OptionItem';
var TypeAhead = /** @class */ (function (_super) {
    __extends(TypeAhead, _super);
    function TypeAhead(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            text: _this.props.text || '',
            filteredItems: _this.props.filteredItems || [],
            isEditing: true,
            isSearching: false,
        };
        _this.handleOnChange = _this.handleOnChange.bind(_this);
        _this.handleOnPaste = _this.handleOnPaste.bind(_this);
        _this.handleOnSelect = _this.handleOnSelect.bind(_this);
        _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
        _this.handleKeyUpClick = _this.handleKeyUpClick.bind(_this);
        _this.containerRef = React.createRef();
        return _this;
    }
    TypeAhead.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        this.setState({ text: nextProps.text, isSearching: false });
        if (nextProps.filteredItems !== this.props.filteredItems) {
            this.setState({ filteredItems: nextProps.filteredItems });
        }
    };
    TypeAhead.prototype.componentDidMount = function () {
        document.addEventListener('mousedown', this.handleDocumentClick);
        document.addEventListener('keyup', this.handleKeyUpClick);
    };
    TypeAhead.prototype.componentWillUnmount = function () {
        document.removeEventListener('mousedown', this.handleDocumentClick);
        document.removeEventListener('keyup', this.handleKeyUpClick);
    };
    TypeAhead.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, deleted = _a.deleted, displayRenderer = _a.displayRenderer, maxLength = _a.maxLength, placeholder = _a.placeholder;
        var _b = this.state, filteredItems = _b.filteredItems, isSearching = _b.isSearching, showResults = _b.showResults, text = _b.text;
        return (React.createElement(exports.Container, { className: className, tabIndex: 1, ref: function (c) {
                _this.containerRef = c;
            } },
            React.createElement(exports.Input, { placeholder: placeholder, onChange: this.handleOnChange, onPaste: this.handleOnPaste, deleted: deleted, maxLength: maxLength, readOnly: deleted, value: text }),
            showResults && !isSearching && (React.createElement(ResultsContainer, null, filteredItems && filteredItems.length > 0 ? (filteredItems.map(function (option, index) {
                return (React.createElement(OptionItem, { key: option.code, onClick: function () { return _this.handleOnSelect(option); } }, displayRenderer ? displayRenderer(option) : option.text));
            })) : (React.createElement(OptionItem, { key: 'no-results' }, "no results"))))));
    };
    TypeAhead.prototype.handleOnChange = function (event) {
        var _a = this.props, items = _a.items, minChar = _a.minChar, onChange = _a.onChange, onSearch = _a.onSearch, remote = _a.remote;
        var searchText = event.target.value;
        var isSearching = true;
        if (!remote) {
            var filteredItems = [];
            if (searchText.length >= minChar) {
                filteredItems = lodash_1.default.filter(items, function (option) { return matching_1.MatchingUtil.testObjectMatch(option, searchText, ['code']); });
            }
            this.setState({ filteredItems: filteredItems });
            isSearching = false;
        }
        this.setState({ isEditing: true, showResults: searchText.length >= minChar, text: searchText, isSearching: isSearching });
        if (onChange) {
            onChange(searchText, event);
        }
        if (remote && onSearch) {
            onSearch(searchText, event);
        }
    };
    TypeAhead.prototype.handleOnSelect = function (option, event) {
        this.setState({ showResults: false, filteredItems: [], text: option.code });
        var onSelect = this.props.onSelect;
        if (onSelect) {
            onSelect(option, event);
        }
    };
    TypeAhead.prototype.handleOnPaste = function (event) {
        var clipboardData = event.clipboardData.getData('Text');
        var onPaste = this.props.onPaste;
        if (onPaste) {
            onPaste(clipboardData, event);
        }
    };
    TypeAhead.prototype.handleKeyUpClick = function (e) {
        if (this.state.isEditing) {
            var items = this.props.items;
            if (e.keyCode === 9) {
                // Hide search results when clicked on anywhere else on the page
                this.setState({ isEditing: false, showResults: false, filteredItems: [] });
                var text_1 = this.state.text;
                var option = lodash_1.default.find(items, function (o) {
                    return o.code.toUpperCase() === text_1.toUpperCase();
                });
                var onSelect = this.props.onSelect;
                if (onSelect) {
                    onSelect(option || { code: text_1, text: '' }, e);
                }
            }
        }
    };
    TypeAhead.prototype.handleDocumentClick = function (e) {
        if (this.state.isEditing) {
            // FIX: no-find-dom-node issue
            // (see https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md)
            // eslint-disable-next-line react/no-find-dom-node
            var element = ReactDOM.findDOMNode(this.containerRef);
            if (element) {
                if (element.contains(e.target) && !this.state.showResults) {
                    // Show search results when clicked on SearchBox
                    this.setState({
                        isEditing: true,
                    });
                }
                else if (!element.contains(e.target)) {
                    var activeElement = document.activeElement;
                    if (element.contains(activeElement)) {
                        // Hide search results when clicked on anywhere else on the page
                        this.setState({ isEditing: false, showResults: false, filteredItems: [] });
                        var onSelect = this.props.onSelect;
                        if (onSelect) {
                            onSelect({
                                code: this.state.text || '',
                                text: '',
                            }, e);
                        }
                    }
                }
            }
        }
    };
    // Default props
    TypeAhead.defaultProps = {
        minChar: 1,
    };
    return TypeAhead;
}(React.Component));
exports.TypeAhead = TypeAhead;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
